import React from "react";
import "./App.css";

function Extraordinary() {
  return (
    <div className="page-container content-page">
      <div className="container">
        <h1 className="page-title">You Are Not Ordinary</h1>

        <div className="philosophy-content">
          <div className="philosophy-text large-text">
            <h3>Why Every Patient is Unique</h3>
            <p>
              "In my years of medical practice, I have come to understand that
              no two human bodies function in exactly the same way, just as no
              two life stories are alike. Every patient who walks into my clinic
              brings a unique blend of physical conditions, personal
              experiences, emotions, and expectations. I do not see you as a
              routine case or a number in a system—I see you as an individual.
              You are not ordinary. You are a distinctive composition of
              biology, resilience, and spirit. This belief shapes the way I
              diagnose, treat, and care for my patients. The awards and
              recognitions I have received are not merely personal achievements;
              they reflect a deeper commitment to delivering thoughtful,
              compassionate, and personalized care. They stand as a testament to
              my conviction that every patient deserves attention that goes
              beyond standard treatment—care that is truly extraordinary."
            </p>
            <p>
              {" "}
              <br></br> ~Sunil Kumar Singh
            </p>
          </div>
          <h3 className="awards-title">Recognition & Awards</h3>
          {/* Start of Grid */}
          <div className="awards-grid">
            {/* Award 1 */}
            <div className="award-placeholder no-border">
              <img
                src="/a1.jpg"
                alt="Dr. Sunil Kumar Singh"
                className="award-img-contain"
              />
            </div>

            {/* Award 2 */}
            <div className="award-placeholder no-border">
              <img
                src="/a2.jpg"
                alt="Dr. Sunil Kumar Singh"
                className="award-img-contain"
                id="two"
              />
            </div>

            {/* Award 3 */}
          </div>{" "}
          {/* <--- Grid closes HERE now, after all 3 items */}
        </div>
      </div>
    </div>
  );
}

export default Extraordinary;
